module.exports = __webpack_public_path__ + "static/landingDesktop@2x-e6b421889bf279256eadb6070bd380d6.png";